export const checkForOverlap = async (updatedRows, setOverlapMessage, identifiant) => {
    const token = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_API_URL;
    let overlapMessages = [];  
    for (const row of updatedRows) {
        const { passport, clientCheckIn, clientCheckOut } = row;

        if (!passport || !clientCheckIn || !clientCheckOut) {
            continue; 
        }
        try {
            const response = await fetch(`${apiUrl}/api/check-overlap`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ passport, clientCheckIn, clientCheckOut, identifiant }),
            });


            console.log("responseeeeeeeeeeeeeeee",response);

            if (!response.ok) {
                const data = await response.json();

                if (response.status === 409) {
                    const conflictingIds = data.conflictingIds.join(', ');
                    overlapMessages.push(`Les dates du passeport ${passport} chevauchement avec un ou plusieurs enregistrements existants facture (s): ${conflictingIds}`);
                } else {
                    overlapMessages.push('An error occurred while checking for overlaps.');
                }
            } else {
                overlapMessages.push('');
            }
        } catch (error) {
            console.error('Error while checking overlap:', error);
            overlapMessages.push('An error occurred while checking for overlaps.');
        }
    }
    console.log("overlapMessages.join('\n')",overlapMessages.join('\n'));
    setOverlapMessage(overlapMessages.length > 0 ? overlapMessages.join('\n') : '');
};
